import Backbone from 'backbone';
import Chaplin from 'chaplin';
import _ from 'lodash';

const Question = Chaplin.Model.extend({
  constructor: function () {
    Backbone.Model.apply(this, arguments);

    if (this.get('shuffle')) {
      this._shuffleAnswers();
    }
  },

  answersForDisplay: function (callback) {
    const A_char_code = 'A'.charCodeAt(0);
    this.get('answers').each(function (answer, idx) {
      const obj = {
        letter: String.fromCharCode(A_char_code + idx),
        text: answer.get('text'),
      };
      if (callback) {
        callback(obj);
      }
      return obj;
    });
  },

  _shuffleAnswers: function () {
    // Fisher-Yates shuffle algo
    const answers = this.get('answers');
    let rand_idx, tempVal;
    let current_index = answers.length;
    while (current_index !== 0) {
      rand_idx = Math.floor(Math.random() * current_index);
      current_index -= 1;

      tempVal = answers[rand_idx];
      answers[rand_idx] = answers[current_index];
      answers[current_index] = tempVal;
    }
    this.set('answers', answers);
  },
  isSuccessAttempt: function (answerIds) {
    let selectedAnswersId = answerIds?.toString(),
      correct_answer = this.get('correct_answer')?.toString();
    const isFreeResponse = this.get('questionTemplate') === 'free_response';

    if (isFreeResponse) {
      return true;
    }
    const correct_answers = this.get('correct_answers'),
      isMultipleSelection = this.get('response_type') === 'multiple_selection';
    if (isMultipleSelection || this.has('correct_answers')) {
      selectedAnswersId = selectedAnswersId?.split(',');
      correct_answer = correct_answer?.split(',');
    }
    if (this.has('correct_answers')) {
      return selectedAnswersId.every(answer => correct_answers.map(a => a.toString()).includes(answer));
    }
    if (isMultipleSelection) {
      return _.isEqual(selectedAnswersId.sort(), correct_answer.sort());
    }
    return selectedAnswersId === correct_answer;
  },
});

export default Question;
